module.exports = __webpack_public_path__ + "img/70800.4040baf7.jpg";